import { useMemo, useState } from "react";
import { ScrollDirection, ScrollState } from "./fade-horizontal-scroll.hooks";
import { MDSIconButtonVariant } from "@/mds/components/buttons";
import { MDSIconKind } from "@/mds/components/icon";
import { StyledIconButton } from "./horizontal-scroll-button.styles";

interface HorizontalScrollButtonProps {
  direction: ScrollDirection;
  scrollState: ScrollState;
  startScrolling: (direction: ScrollDirection) => void;
  stopScrolling: () => void;
  scrollForDuration: (direction: ScrollDirection, duration: number) => void;
  variant: "standard" | "inverted";
  scrollButtonClassName?: string;
}

export const MDSHorizontalScrollButton = ({
  direction,
  scrollState,
  startScrolling,
  stopScrolling,
  scrollForDuration,
  scrollButtonClassName,
}: HorizontalScrollButtonProps) => {
  const [pressStartTime, setPressStartTime] = useState<number | null>(null);

  const handlePressStart = () => {
    setPressStartTime(Date.now());
    startScrolling(direction);
  };

  const handlePressEnd = () => {
    if (pressStartTime && Date.now() - pressStartTime < 100) {
      scrollForDuration(direction, 600);
    } else {
      setPressStartTime(null);
      stopScrolling();
    }
  };

  const { isVisible, iconKind } = useMemo(() => {
    if (direction === ScrollDirection.Left)
      return {
        isVisible: scrollState.leftVisible,
        iconKind: MDSIconKind.AngleLeft,
      };

    return {
      isVisible: scrollState.rightVisible,
      iconKind: MDSIconKind.AngleRight,
    };
  }, [direction, scrollState]);

  return (
    <StyledIconButton
      data-mds-name="horizontal-scroll-button"
      variant={MDSIconButtonVariant.Floating}
      iconKind={iconKind}
      onPressStart={handlePressStart}
      onPressEnd={handlePressEnd}
      className={scrollButtonClassName}
      $isVisible={isVisible}
      $direction={direction}
      rounded
    />
  );
};
